export default function ({$axios, redirect}) {
	// $axios.onRequest(config => {
	// 	// console.log('Making ' + config.method.toUpperCase() + ' request to ' + config.url);
	// });

	$axios.onError(error => {
		const code = parseInt(error.response && error.response.status);
		if (code === 404) {
			redirect('/404');
		} else {
			throw error.response;
		}
	});
}
